import {User} from '../../user/user.model';
import {Place} from './place.model';
import {Event} from '../event.model';

export class Address {
    id: number;
    address1: string;
    address2: string;
    zipCode: string;
    city: string;
    country: string;
    dateUpdate: Date;
    qva: boolean;
    qvp: boolean;

    users: User[];
    places: Place[];
    events: Event[];
}
